import { List, Datagrid, TextField } from 'react-admin';

export const LlmModelsList = (props: any) => (
  <List {...props} sort={{ field: 'name', order: 'ASC' }} hasCreate={false}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" />
      <TextField source="purpose" />
      <TextField source="provider" />
    </Datagrid>
  </List>
);
